
import Typography from '@mui/material/Typography';


export const TextDrugEfavirez = () => {

return(
<div>
    
<Typography variant="h6" >
<br />

The combination of efavirenz, emtricitabine, and tenofovir is used alone or along with other medications to treat human immunodeficiency virus (HIV) infection 
in adults and children weighing more than 40 kg (88 lb). Efavirenz is in a class of medications non-nucleoside reverse transcriptase inhibitors (NNRTIs). 
Emtricitabine and tenofovir are in a class of medications called nucleoside reverse transcriptase inhibitors (NRTIs). 
They work by decreasing the amount of HIV in the body. Although efavirenz, emtricitabine, and tenofovir will not cure HIV, 
these medications may decrease your chance of developing acquired immunodeficiency syndrome (AIDS) and HIV-related illnesses such as serious infections or cancer. 
Taking these medications along with practicing safer sex and making other lifestyle changes may decrease the 
risk of getting or transmitting the HIV virus to other people.
<br /><br />



Sources: <br /><br />
https://medlineplus.gov/druginfo/meds/a616048.html 


</Typography>

</div>

)
}